module.exports = __webpack_public_path__ + "static/img/government-icon-3.1634a529.png";